import Layout from '@layout/Index'

export const satisfactionEmail = [
  {
    path: '/satisfaction-email',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "satisfaction-email-table" */ './pages/SatisfactionEmailTable.vue'),
        name: '满意度邮件',
        meta: {
          title: '满意度邮件',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "satisfaction-email-form" */ './pages/SatisfactionEmailForm.vue'),
        name: '新增邮件',
        meta: {
          title: '新增邮件',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "satisfaction-email-form" */ './pages/SatisfactionEmailForm.vue'),
        name: '修改满意度邮件',
        meta: {
          title: '修改满意度邮件',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "satisfaction-email-detail" */ './pages/SatisfactionEmailDetail.vue'),
        name: '查看满意度邮件',
        meta: {
          title: '查看满意度邮件',
        },
      },
      {
        path: 'push-log/:id',
        component: () => import(/* webpackChunkName: "satisfaction-email-push-log" */ './pages/SatisfactionEmailPushLog.vue'),
        name: '推送记录',
        meta: {
          title: '推送记录',
        },
      },
      {
        path: 'log/:id',
        component: () => import(/* webpackChunkName: "satisfaction-email-log-table" */ './pages/SatisfactionEmailLogTable.vue'),
        name: '修改日志',
        meta: {
          title: '修改日志',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/satisfaction-email/satisfaction-email.route.js